module.exports = __webpack_public_path__ + "img/5.7fdb0e7e.jpg";